export function consfigFieldsClosing(values) {
    return {
      type: '@ACTION_CONFIG_FIELDS',
      payload: values
    };
  }